const getInteriors = (t) => ({
  zeroInt: '',
  all: t('constants.interiors.all'),
  chernInt: t('constants.interiors.chernInt'),
  chistInt: t('constants.interiors.chistInt'),
  whiteBox: t('constants.interiors.whiteBox'),
  repair: t('constants.interiors.repair'),
  predChistInt: t('constants.interiors.predChistInt'),
  remInt: t('constants.interiors.remInt'),
  chastRemInt: t('constants.interiors.chastRemInt'),
});

export default getInteriors;



// WEBPACK FOOTER //
// ./src/constants/interiors.js